function SliderEvents(container){
	var _this = this;
	this.container = $(container);
	_this.container.flexslider({
		pauseOnHover: true,
		animation: 'slide',
		animationLoop: false,
		itemMargin: 0,
		move: 1,
		useCSS: false,
		controlNav: false,
		directionNav: true,
		startAt: 0,
		slideshow: false,
		slideshowSpeed: 5000
	});
}

if (typeof define === "function" && define.amd) {
	define('Controls/SliderEvents',['flexslider'], function() {
		return SliderEvents;
	});
};
